import React from 'react';
import _ from 'lodash';
import externalService from '../../service/external';
import { appContext } from '../../util/decorators';
import Notifications from './Notifications.jsx';

const FIVE_MINUTES = 1000 * 60 * 5;

@appContext
export default class NotificationsWrapper extends React.PureComponent {
  static propTypes = {
    country: React.PropTypes.string.isRequired,
    language: React.PropTypes.string.isRequired,
  };

  constructor() {
    super();
    this.getTechNotifications = this.getTechNotifications.bind(this);
    this.state = {
      countryNotification: {},
      techNotifications: [],
    };
  }

  componentDidMount() {
    this.getTechNotifications();

    if (!localStorage.getItem('notification_dismissed_country-warning')) {
      this.getCountryNotification();
    }

    // Check for new notifications every five minutes
    this.notificationInterval = setInterval(this.getTechNotifications, FIVE_MINUTES);
  }

  componentWillUnmount() {
    clearInterval(this.notificationInterval);
  }

  async getCountryNotification() {
    const { country } = this.props;
    const userCountry = await externalService.getUserRegion(country);

    if (userCountry !== country) {
      this.setState({
        countryNotification: {
          type: 'is-warning',
          data: {
            meta: {
              id: 'country-warning',
              body: this.context.app.t('Notifications.country_warning'),
            },
          },
        },
      });
    }
  }

  async getTechNotifications() {
    const techNotifications = await externalService.getTechNotifications(`${this.props.language}-${this.props.country}`);
    if (techNotifications && techNotifications.length) {
      this.setState({ techNotifications });
    }
  }

  render() {
    const { techNotifications, countryNotification } = this.state;
    let notifications = techNotifications;

    if (!_.isEmpty(countryNotification)) {
      notifications = notifications.concat([countryNotification]);
    }

    return <Notifications notifications={notifications} />;
  }
}



// WEBPACK FOOTER //
// ./src/component/Navigation/NotificationsWrapper.jsx